import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query'
import { ChatMessage, getLatestMessages } from 'api/message'
import { useAuthContext } from 'components/auth'
import { latestMessagesKey } from './keys'

export function useLatestMessages() {
  const { company } = useAuthContext()

  return useInfiniteQuery({
    queryKey: latestMessagesKey,
    queryFn: ({ pageParam }) => {
      if (!company?.id) {
        throw new Error('Company ID not found')
      }
      return getLatestMessages(company.id, pageParam)
    },
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage?.cursor ?? null,
    enabled: Boolean(company?.id),
  })
}

export function useResetUnreadCount(workerId: number) {
  const queryClient = useQueryClient()

  return {
    resetUnreadCount: () => {
      queryClient.setQueryData<ChatMessage[]>(latestMessagesKey, (prevData) => {
        if (!prevData) {
          return prevData
        }

        return prevData.map((message) => ({
          ...message,
          unreadCount:
            Number(message.fromUser.id) === Number(workerId)
              ? 0
              : message.unreadCount,
        }))
      })
    },
  }
}
